import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import RoxyLauncher from './Roxy/RoxyLauncher';
import RoxyPanel from './RoxyPanel';

const AiChat = ({ applicationId, applicationName, chatStatus, onRefreshChatStatus, creditCosts, creditUsageEnabled }) => {
    const [open, setOpen] = useState(false);
    const [unread, setUnread] = useState(false);

    useEffect(() => {
        if (!open && chatStatus?.status === 'STARTED') setUnread(true);
    }, [chatStatus, open]);

    const handleOpen = () => {
        setUnread(false);
        setOpen(true);
    };


    return ReactDOM.createPortal(
        <>
            <RoxyLauncher onClick={handleOpen} unread={unread} hidden={open} />
            <RoxyPanel
                applicantId={applicationId}
                applicationName={applicationName}
                open={open}
                onClose={() => setOpen(false)}
                chatStatus={chatStatus}
                onRefreshChatStatus={onRefreshChatStatus}
                creditCosts={creditCosts}
                creditUsageEnabled={creditUsageEnabled}
            />
        </>,
        document.body
    );
};

export default AiChat;
